module.exports = __webpack_public_path__ + "static/media/32.c004967b.svg";